import api from './api';

export async function getSubdomainAvailability({ subdomain }) {
  try {
    return await api.get(`/rest/wl/availability?subdomain=${subdomain}`);
  } catch (error) {
    console.error('Error fetching white label info:', error);
    throw error;
  }
}

export async function checkDiscountCode({ discountCode }) {
  try {
    return await api.post('/rest/subscription/coupon', {
      couponCode: discountCode,
    });
  } catch (error) {
    console.error('Error checking discount code:', error);
    throw error;
  }
}

export async function changePlan({ plan }) {
  const subscriptionTier = plan?.value;
  const isRegistering = true;
  try {
    return await api.post('/rest/subscription/upgrade', {
      subscriptionTier,
      isRegistering,
    });
  } catch (error) {
    console.error('Error changing plan:', error);
    throw error;
  }
}

export async function saveWhiteLabelInfo({
  agencyId,
  companyName,
  domain,
  subdomain,
}) {
  try {
    const whiteLabel = { companyName, domain, subdomain };
    return await api.post('/rest/wl/save', { agencyId, whiteLabel });
  } catch (error) {
    console.error('Error saving white label info:', error);
    throw error;
  }
}

export async function registerUser({ payload }) {
  try {
    return await api.post('/rest/subscription/register', payload);
  } catch (error) {
    console.error('Error registering user:', error);
    throw error;
  }
}

export async function getQuote({
  quoteId,
  subscriptionTier,
  annual,
  quantity,
  couponCode,
  customerId,
}) {
  try {
    const response = await api.post('/rest/subscription/quote', {
      quoteId,
      subscriptionTier,
      annual,
      quantity,
      couponCode,
      customerId,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching quote:', error);
    throw error;
  }
}

export async function submitPayment({
  paymentToken,
  subscriptionTier,
  couponCode,
  annual,
}) {
  try {
    return await api.post('/rest/subscription/payment', {
      paymentToken,
      subscriptionTier,
      couponCode,
      annual,
    });
  } catch (error) {
    console.error('Error submitting payment:', error);
    throw error;
  }
}

export async function getPlanPricing() {
  try {
    const response = await api.get('/rest/subscription/pricing');
    return response.data;
  } catch (error) {
    console.error('Error fetching plan pricing:', error);
    throw error;
  }
}

export async function getChurnkeyHash({ stripeCustomerId }) {
  try {
    const response = await api.get(
      `/rest/subscription/churnkey-hash?stripeCustomerId=${encodeURIComponent(stripeCustomerId)}`,
    );
    return {
      authHash: response.data.authHash,
      appId: response.data.appId,
    };
  } catch (error) {
    console.error('Error fetching Churnkey hash:', error);
    throw error;
  }
}

export async function getInvoices() {
  try {
    const response = await api.get('/rest/dashboard/invoices');
    return response.data;
  } catch (error) {
    console.error('Error fetching invoices:', error);
    throw error;
  }
}
